import { type FC } from 'react'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { useQuery } from '@tanstack/react-query'
import { Cards, ICard } from './components/Cards'
import { getCurrencies } from '../../utils/api'
import MaibRedirect from '../../components/MaibRedirect'
import MainCarousel from './components/MainCarousel'
import Currencies from './components/Currencies'

const cards: ICard[] = [
  {
    title: 'main-page.cards.card1.title',
    description: 'main-page.cards.card1.description',
    button: 'main-page.cards.card1.button',
    link: 'https://maibank.maib.md/payments/p2p',
  },
  {
    title: 'main-page.cards.card2.title',
    description: 'main-page.cards.card2.description',
    button: 'main-page.cards.card2.button',
    link: '/t2c',
  },
  {
    title: 'main-page.cards.card3.title',
    description: 'main-page.cards.card3.description',
    button: 'main-page.cards.card3.button',
    link: 'https://maibank.maib.md/payments/p2p',
  },
]

const MainPage: FC = () => {
  const {
    data: curr,
    isError,
    isLoading,
  } = useQuery(['currencies'], () => getCurrencies(), {
    refetchOnMount: true,
  })

  return (
    <div className='h-full flex flex-1 w-full flex-col'>
      <MainCarousel />
      <Cards items={cards as ICard[]} />
      <div className='flex flex-col items-center justify-center my-12'>
        <div className='container mx-auto flex md:flex-row flex-col gap-8 px-4 items-stretch justify-center'>
          <Currencies curr={curr?.result || []} isLoading={isLoading} isError={isError} />
        </div>
        <div className='container mx-auto flex md:flex-row flex-col pt-12 px-4 items-stretch justify-between'>
          <MaibRedirect />
        </div>
      </div>
    </div>
  )
}
export default MainPage
